module.exports = __webpack_public_path__ + "static/media/skatepark.06c4d35c.webp";